(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function preservePreviewThemeLinks() {
    const params = new URLSearchParams(window.location.search);
    const previewThemeId = params.get('preview_theme_id');

    if (!previewThemeId) return;

    document.querySelectorAll('a[href]').forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;

      let url;
      try {
        url = new URL(href, window.location.origin);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin) return;
      if (url.searchParams.has('preview_theme_id')) return;

      url.searchParams.set('preview_theme_id', previewThemeId);
      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    });
  }

  function routeBookingLinksToCalendar() {
    const bookingPath = '/pages/pages-haircut-beard-grooming-menspot';

    document.querySelectorAll('a[href]').forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;

      let url;
      try {
        url = new URL(href, window.location.origin);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin) return;
      if (url.pathname !== bookingPath || url.hash) return;

      url.hash = 'book-now';
      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    });
  }

  function initBookingSelector() {
    const frame = document.querySelector('[data-ms-acuity-frame]');
    const options = Array.from(document.querySelectorAll('[data-ms-booking-option]'));
    const current = document.querySelector('[data-ms-booking-current]');
    const stage = document.querySelector('#book-now');

    if (!frame || !options.length) return;

    function selectBooking(option, shouldScroll) {
      const src = option.getAttribute('data-ms-booking-src');
      const service = option.getAttribute('data-ms-booking-service');
      const label = option.getAttribute('data-ms-booking-label') || 'MENSPOT service';

      if (!src || !service) return;

      options.forEach((item) => {
        const isMatch = item.getAttribute('data-ms-booking-service') === service;
        item.classList.toggle('is-active', isMatch);
        item.setAttribute('aria-current', isMatch ? 'true' : 'false');
      });

      if (current) current.textContent = `Selected: ${label}`;

      if (frame.getAttribute('src') !== src) {
        frame.setAttribute('src', src);
      }

      if (shouldScroll && stage) {
        stage.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    options.forEach((option) => {
      option.addEventListener('click', (event) => {
        event.preventDefault();
        selectBooking(option, true);
      });
    });

    const active = options.find((option) => option.classList.contains('is-active')) || options[0];
    selectBooking(active, false);
  }

  function initThemeToggle() {
    const key = 'menspot-theme';
    const root = document.documentElement;
    const toggle = document.querySelector('[data-ms-theme-toggle]');
    const label = toggle && toggle.querySelector('[data-ms-theme-label]');
    const metaTheme = document.querySelector('meta[name="theme-color"]');

    function applyTheme(theme) {
      const isLight = theme === 'light';
      root.setAttribute('data-ms-theme', isLight ? 'light' : 'dark');

      if (toggle) {
        toggle.setAttribute('aria-pressed', isLight ? 'true' : 'false');
        toggle.setAttribute('aria-label', isLight ? 'Switch to dark mode' : 'Switch to light mode');
      }

      if (label) label.textContent = isLight ? 'Light' : 'Dark';
      if (metaTheme) metaTheme.setAttribute('content', isLight ? '#f3f4f4' : '#0b0b0b');
    }

    let currentTheme = root.getAttribute('data-ms-theme') === 'light' ? 'light' : 'dark';
    applyTheme(currentTheme);

    if (!toggle) return;

    toggle.addEventListener('click', () => {
      currentTheme = currentTheme === 'light' ? 'dark' : 'light';
      try {
        window.localStorage.setItem(key, currentTheme);
      } catch (error) {
        // Preference storage can fail in restricted browsers; the visual switch still works.
      }
      applyTheme(currentTheme);
    });
  }

  function initRevealMotion() {
    document.documentElement.classList.add('ms-motion-ready');

    const revealSelectors = [
      '.ms-section__head',
      '.ms-hero-booking',
      '.ms-booking-priority__inner',
      '.ms-booking-command__inner',
      '.ms-atelier__copy',
      '.ms-atelier__frame',
      '.ms-logo-stage__copy',
      '.ms-logo-stage__visual',
      '.ms-journey article',
      '.ms-real-gallery__item',
      '.ms-appointment-command__copy',
      '.ms-command-list a',
      '.ms-cinematic__item',
      '.ms-ritual-ledger__image',
      '.ms-ritual-ledger__copy',
      '.ms-service-suite article',
      '.ms-brand-architecture__copy',
      '.ms-brand-architecture__panel',
      '.ms-contact-concierge__copy',
      '.ms-contact-concierge figure',
      '.ms-portal-art figure',
      '.ms-product-path__proof span',
      '.ms-ecosystem__panel',
      '.ms-lux-product',
      '.ms-experience__copy',
      '.ms-experience__media',
      '.ms-future__grid span',
      '.ms-social__inner',
      '.ms-final-booking__inner',
      '.ms-service',
      '.ms-price-card',
      '.ms-bundle-card',
      '.ms-action-tile',
      '.ms-action-dock',
      '.ms-ritual-card',
      '.ms-package-grid article',
      '.ms-protocol__grid article',
      '.ms-instafeed-stage',
      '.ms-contact-card'
    ];

    const elements = Array.from(document.querySelectorAll(revealSelectors.join(',')));
    elements.forEach((element, index) => {
      element.classList.add('ms-reveal');
      element.style.setProperty('--ms-reveal-delay', `${Math.min(index % 4, 3) * 55}ms`);
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -6% 0px'
    });

    elements.forEach((element) => observer.observe(element));
  }

  function initFullCardLinks() {
    const cardSelectors = [
      '.ms-service-suite article',
      '.ms-price-card',
      '.ms-bundle-card',
      '.ms-package-grid article',
      '.ms-fashion-store__product',
      '.ms-fashion-store__steps article',
      '.ms-service',
      '.ms-journey article',
      '.ms-ritual-card',
      '.ms-collection-card',
      '.article-card',
      '.blog-articles__article',
      '.product-card-wrapper .card',
      '.card-wrapper .card'
    ];
    const interactiveSelector = [
      'a',
      'button',
      'input',
      'select',
      'textarea',
      'label',
      'summary',
      'form',
      '[role="button"]',
      '[data-ms-booking-option]',
      '.quantity',
      '.product-form',
      '.quick-add',
      '.shopify-payment-button'
    ].join(',');

    function getMainLink(card) {
      const preferredLink = card.querySelector([
        '.ms-card-link[href]',
        '.ms-fashion-store__view[href]',
        '.full-unstyled-link[href]',
        '.card__heading a[href]',
        'h3 a[href]',
        'a[href]'
      ].join(','));

      if (!preferredLink) return null;
      const href = preferredLink.getAttribute('href');
      if (!href || href === '#') return null;
      return preferredLink;
    }

    function followLink(link) {
      const href = link.getAttribute('href');
      if (!href) return;

      if (link.target === '_blank') {
        window.open(href, '_blank', 'noopener');
        return;
      }

      link.click();
    }

    document.querySelectorAll(cardSelectors.join(',')).forEach((card) => {
      if (card.matches('a[href], button, form')) return;
      if (card.querySelector('form, .product-form, .quick-add, .shopify-payment-button') && !card.matches('.ms-fashion-store__product, .card, .product-card-wrapper .card, .card-wrapper .card')) {
        return;
      }

      const mainLink = getMainLink(card);
      if (!mainLink) return;

      card.classList.add('ms-card-clickable');
      card.setAttribute('role', 'link');
      card.setAttribute('tabindex', '0');
      card.setAttribute('data-ms-card-clickable', 'true');
      if (!card.getAttribute('aria-label')) {
        card.setAttribute('aria-label', mainLink.textContent.trim() || 'Open');
      }

      card.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (event.target.closest(interactiveSelector)) return;
        followLink(mainLink);
      });

      card.addEventListener('keydown', (event) => {
        if (event.defaultPrevented || (event.key !== 'Enter' && event.key !== ' ')) return;
        if (event.target.closest(interactiveSelector) && event.target !== card) return;
        event.preventDefault();
        followLink(mainLink);
      });
    });
  }

  function polishPolicyCopy() {
    const policyBody = document.querySelector('.shopify-policy__body');
    if (!policyBody) return;

    const returnAddress = 'MENSPOT, Cabbabe Center, Main Road, Mazraat Yachouh, Lebanon';
    const walker = document.createTreeWalker(policyBody, NodeFilter.SHOW_TEXT);
    let node;

    while ((node = walker.nextNode())) {
      if (!node.nodeValue || !node.nodeValue.includes('[INSERT RETURN ADDRESS]')) continue;
      node.nodeValue = node.nodeValue.replace(/\[INSERT RETURN ADDRESS\]/g, returnAddress);
    }
  }

  function initLogoStage() {
    const stage = document.querySelector('[data-ms-logo-stage]');
    const canvas = document.querySelector('[data-ms-logo-canvas]');
    const visual = canvas && canvas.closest('.ms-logo-stage__visual');

    if (!stage || !canvas || !visual || reduceMotion || !window.THREE) {
      if (stage) stage.classList.add('ms-logo-stage--fallback');
      return;
    }

    const THREE = window.THREE;
    const renderer = new THREE.WebGLRenderer({
      canvas,
      alpha: true,
      antialias: true,
      preserveDrawingBuffer: true
    });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.6));

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(32, 1, 0.1, 100);
    camera.position.set(0, 0, 7.5);

    const group = new THREE.Group();
    scene.add(group);

    const silver = new THREE.MeshStandardMaterial({
      color: 0xc8cdd2,
      metalness: 0.72,
      roughness: 0.34
    });
    const cream = new THREE.MeshStandardMaterial({
      color: 0xf4f0e8,
      metalness: 0.2,
      roughness: 0.48
    });

    const slash = new THREE.Mesh(new THREE.BoxGeometry(0.12, 4.1, 0.12), silver);
    slash.rotation.z = -0.72;
    slash.position.set(0.12, 0, 0.12);
    group.add(slash);

    const topLine = new THREE.Mesh(new THREE.BoxGeometry(4.8, 0.035, 0.035), cream);
    topLine.position.set(0, 0.86, -0.12);
    topLine.rotation.z = -0.02;
    group.add(topLine);

    const bottomLine = new THREE.Mesh(new THREE.BoxGeometry(4.5, 0.035, 0.035), cream);
    bottomLine.position.set(0, -0.86, -0.12);
    bottomLine.rotation.z = 0.02;
    group.add(bottomLine);

    const frameGeometry = new THREE.BufferGeometry().setFromPoints([
      new THREE.Vector3(-3.1, -1.55, -0.55),
      new THREE.Vector3(3.1, -1.55, -0.55),
      new THREE.Vector3(3.1, 1.55, -0.55),
      new THREE.Vector3(-3.1, 1.55, -0.55),
      new THREE.Vector3(-3.1, -1.55, -0.55)
    ]);
    const frame = new THREE.Line(frameGeometry, new THREE.LineBasicMaterial({
      color: 0xc8cdd2,
      transparent: true,
      opacity: 0.28
    }));
    group.add(frame);

    const ambient = new THREE.AmbientLight(0xffffff, 0.72);
    const key = new THREE.DirectionalLight(0xe8edf1, 2.1);
    key.position.set(2.4, 3, 5);
    const rim = new THREE.DirectionalLight(0xffffff, 0.72);
    rim.position.set(-3, -1, 4);
    scene.add(ambient, key, rim);

    let scrollTarget = 0.5;
    let scrollCurrent = 0.5;
    let frameId = 0;

    function resize() {
      const rect = visual.getBoundingClientRect();
      const width = Math.max(1, Math.round(rect.width));
      const height = Math.max(1, Math.round(rect.height));
      renderer.setSize(width, height, false);
      camera.aspect = width / height;
      camera.updateProjectionMatrix();
    }

    function updateScrollTarget() {
      const rect = stage.getBoundingClientRect();
      const range = window.innerHeight + rect.height;
      scrollTarget = clamp((window.innerHeight - rect.top) / range, 0, 1);
    }

    const clock = new THREE.Clock();
    function animate() {
      const t = clock.getElapsedTime();
      scrollCurrent += (scrollTarget - scrollCurrent) * 0.08;
      const offset = scrollCurrent - 0.5;

      group.rotation.y = offset * 0.42 + Math.sin(t * 0.34) * 0.025;
      group.rotation.x = -offset * 0.08;
      group.position.x = offset * 0.24;
      slash.rotation.z = -0.72 + offset * 0.1;
      frame.rotation.z = offset * 0.035;

      renderer.render(scene, camera);
      frameId = window.requestAnimationFrame(animate);
    }

    resize();
    updateScrollTarget();
    animate();

    window.addEventListener('resize', () => {
      resize();
      updateScrollTarget();
    }, { passive: true });
    window.addEventListener('scroll', updateScrollTarget, { passive: true });

    document.addEventListener('shopify:section:unload', () => {
      window.cancelAnimationFrame(frameId);
      renderer.dispose();
    }, { once: true });
  }

  ready(() => {
    preservePreviewThemeLinks();
    routeBookingLinksToCalendar();
    initBookingSelector();
    initThemeToggle();
    initFullCardLinks();
    polishPolicyCopy();
    initRevealMotion();
    initLogoStage();
  });
})();
